import {
    Alert,
    Button,
    Card,
    Col,
    Divider,
    Form,
    Input,
    message,
    Modal,
    Radio,
    Row,
    Select,
    Space,
    Spin,
    Table,
    Tag,
    Tooltip
} from "antd";
import {
    CheckOutlined,
    CloseOutlined,
    DownloadOutlined,
    ExclamationCircleOutlined,
    EyeOutlined,
    SearchOutlined
} from "@ant-design/icons";
import React, {useEffect, useRef, useState} from "react";
import ErrorHandler from "../../../util/ErrorHandler";
import {ContactDetailDto} from "../../../dto/ContactDetailDto";
import customerChangeRequestAdminService from "../../../service/customerChangeRequestAdminService";
import modal from "antd/es/modal";
import {
    CHANGE_REQUEST_RECORD_STATUS,
    COMMON_DROPDOWN,
    DOCUMENT_TYPES,
    IDENTIFICATION_SOURCE,
    NOT_AVAILABLE,
    PARAMETER_LIST,
    PREVIEW_DOC_TYPES,
    YYYY_MM_DD_HH_MM
} from "../../../util/Constants";
import TextArea from "antd/es/input/TextArea";
import {
    MSG_CONTACT_DETAIL_LIST_FETCH_FAILURE_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR,
    MSG_FAILED_TO_FETCH_BANK_LIST_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_PLEASE_SELECT_BANK_STATUS,
    MSG_PLEASE_SELECT_BOTH_BANK_STATUES
} from "../../../util/Messages";
import Highlighter from "react-highlight-words";
import {InputRef} from "antd/es/input";
import {FilterConfirmProps} from "antd/es/table/interface";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import customerService from "../../../service/customerService";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import documentService from "../../../service/documentService";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import {DefaultDocumentDto} from "../../../dto/DefaultDocumentDto";
import {BankDetailDto} from "../../../dto/BankDetailDto";
import {toNumber} from "lodash";
import Validation from "../../../util/Validation";
import PreviewModalComp from "../../common/preview/PreviewModalComp";
import dayjs from "dayjs";
import ChangeRequestHistoryTableComp from "../../customerRequests/history/changeRequestHistoryTableComp";
import customerChangeRequestService from "../../../service/customerChangeRequestService";
import {DraggableData, DraggableEvent} from "react-draggable";
import {isCustomer} from "../../../security/KeyclockConfig";


enum RECORD_STATUS {
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
}

interface BankAccDetailProps {
    isFromHst: boolean,
    bankDetailDtoList?: BankDetailDto[]
    handleTabChange?: (activeKey: string) => void
}

type DataIndex = keyof ContactDetailDto;
const BankAccountDetailsUpdateRequestListComp = (props: BankAccDetailProps) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef<InputRef>();
    const [isLoading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPrimaryBankRejectReasonModalOpen, setPrimaryBankRejectReasonModalOpen] = useState(false);
    const [isSecondaryBankRejectReasonModalOpen, setSecondaryBankRejectReasonModalOpen] = useState(false);
    const [bankDetailList, setBankDetailList] = useState([])
    const [selectedRow, setSelectedRow] = useState<BankDetailDto[]>([])

    const [cin, setCin] = useState<string>("")
    const [primaryRejectReason, setPrimaryRejectReason] = useState<string | null>(null)
    const [secondaryRejectReason, setSecondaryRejectReason] = useState<string | null>(null)
    const [bankList, setBankList] = useState<DropdownListDto[]>([]);
    const [branchListPrimary, setBranchListPrimary] = useState<DropdownListDto[]>([]);
    const [branchListSec, setBranchListSecondary] = useState<DropdownListDto[]>([]);
    const [jobNumber, setJobNumber] = useState<string>("")
    const [primaryDefaultSelectedValue, setPrimaryDefaultSelectedValue] = useState<string | null>(null)
    const [secondaryDefaultSelectedValue, setSecondaryDefaultSelectedValue] = useState<string | null>(null)
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [isPrimaryInfoAvailable, setIsPrimaryInfoAvailable] = useState(false);
    const [isSecondaryInfoAvailable, setIsSecondaryInfoAvailable] = useState(false);
    const [previewTitle, setPreviewTitle] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [isShowRejectReason, setCanShowRejectReason] = useState<boolean>(false)
    const [isShowCancelRequest, setShowCancelRequest] = useState<boolean>(false)
    const [selectedGroupId, setSelectedGroupId] = useState<number>()

    const [primaryBankAccForm] = Form.useForm();
    const [secondaryBankAccForm] = Form.useForm();
    const [rejectReasonForm] = Form.useForm()
    const [disabled1, setDisabled1] = useState(true);
    const [bounds1, setBounds1] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggleRef1 = useRef<HTMLDivElement>(null);

    const [position2, setPosition2] = useState({x: 100, y: 20});
    const modalRef2 = useRef<HTMLDivElement | null>(null);
    const draggingRef2 = useRef<{ offsetX: number; offsetY: number } | null>(null);
    const onStart1 = (_event1: DraggableEvent, uiData1: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggleRef1.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds1({
            left: -targetRect.left + uiData1.x,
            right: clientWidth - (targetRect.right - uiData1.x),
            top: -targetRect.top + uiData1.y,
            bottom: clientHeight - (targetRect.bottom - uiData1.y),
        });
    };

    const onMouseDown = (e: React.MouseEvent<HTMLDivElement>) => {
        if ((e.target as HTMLElement).classList.contains('draggable-modal-title-area')) {
            if (modalRef2.current) {
                const rect = modalRef2.current.getBoundingClientRect();
                draggingRef2.current = {offsetX: e.clientX - rect.left, offsetY: e.clientY - rect.top};
            }
        }
    };

    // Drag the modal
    const onMouseMove = (e: MouseEvent) => {
        if (draggingRef2.current) {
            const {offsetX, offsetY} = draggingRef2.current;
            setPosition2({x: e.clientX - offsetX, y: e.clientY - offsetY});
        }
    };

    // Stop dragging
    const onMouseUp = () => {
        draggingRef2.current = null;
    };

    useEffect(() => {
        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);

    const handleSearch = (
        selectedKeys: string[],
        confirm: (param?: FilterConfirmProps) => void,
        dataIndex: DataIndex,
    ) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters: () => void, dataIndex: DataIndex) => {
        clearFilters();
        setSearchText('');
        setSearchedColumn(dataIndex);
    };
    const getColumnSearchProps = (dataIndex: DataIndex, columnName: string): {
        filterDropdown: ({
                             setSelectedKeys,
                             selectedKeys,
                             confirm,
                             clearFilters,
                             close
                         }: {
            setSelectedKeys: any;
            selectedKeys: any;
            confirm: any;
            clearFilters: any;
            close: any
        }) => JSX.Element;
        filterIcon: (filtered: boolean) => JSX.Element;
        onFilter: (value: any, record: any) => boolean;
        render: (text: any) => any;
        onFilterDropdownOpenChange: (visible: any) => void
    } => ({
        filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => (
            <div className='table-column-search' onKeyDown={(e) => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Search ${columnName}`}
                    value={selectedKeys[0]}
                    onChange={(e: {
                        target: { value: React.Key; };
                    }) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                    style={{marginBottom: 12, display: 'block'}}
                />
                <div className='search-btn-row'>
                    <Button className='tbl-search-btn'
                            type="primary"
                            onClick={() => handleSearch(selectedKeys as string[], confirm, dataIndex)}
                            icon={<SearchOutlined/>}
                            size="small"
                    >
                        Search
                    </Button>
                    <Button className='tbl-search-reset'
                            onClick={() => clearFilters && handleReset(clearFilters, dataIndex)}
                            size="small"
                    >
                        Reset
                    </Button>
                    <Button className='tbl-search-close'
                            size="small"
                            onClick={() => {
                                close();
                            }}
                    >
                        Close
                    </Button>
                </div>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{color: filtered ? '#1677ff' : undefined}}/>
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: (visible) => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{backgroundColor: '#ffc069', padding: 0}}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    const columns = [
        {
            title: 'Request ID',
            dataIndex: 'key',
            render: (text: any, rec: any, index: number) => {
                return (<span>{index + 1}</span>)
            }
        },
        {
            title: 'CIN',
            dataIndex: 'cin',
            key: 'cin',
            sorter: (a: any, b: any) => {
                a = a.cin == null ? '' : a.cin
                b = b.cin == null ? '' : b.cin
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('cin', 'CIN'),
        },
        {
            title: 'Customer Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a: any, b: any) => {
                a = a.name == null ? '' : a.name
                b = b.name == null ? '' : b.name
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('name', 'Customer Name'),
        },
        {
            title: 'Identification Type',
            dataIndex: 'identificationType',
            key: 'identificationType',
            align: 'center',
            sorter: (a: any, b: any) => {
                a = a.identificationType == null ? '' : a.identificationType
                b = b.identificationType == null ? '' : b.identificationType
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('identificationType', 'Identification Type'),
            render: (text: any, rec: any) => {
                return (
                    <Tag
                        className={getClassName(text)}
                        color={getColor(text)} key={text}>
                        {null != text ? text.toUpperCase() : 'N/A'}
                    </Tag>
                )
            }
        },
        {
            title: 'Identification Value',
            dataIndex: 'identificationValue',
            key: 'identificationValue',
            sorter: (a: any, b: any) => {
                a = a.identificationValue == null ? '' : a.identificationValue
                b = b.identificationValue == null ? '' : b.identificationValue
                return a.localeCompare(b);
            },
            ...getColumnSearchProps('identificationValue', 'Identification Value'),
        },
        {
            title: 'Request Date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            sorter: (a: any, b: any) => {
                a = a.createdDate == null ? '' : a.createdDate
                b = b.createdDate == null ? '' : b.createdDate
                return a.localeCompare(b);
            },
            render: (text: any) => (
                <span>{null != text ? dayjs(text).format(YYYY_MM_DD_HH_MM) : NOT_AVAILABLE}</span>
            )
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (rec: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={() => showModal(rec.pendingRequests)}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];

    const getClassName = (text: string) => {
        if (null != text) {
            return text.toUpperCase() == "DRIVING LICENSE" ? 'drl-tbl-tag' : 'tbl-tag'
        }
        return 'tbl-tag';
    }

    const getColor = (identificationSourceType: string) => {
        switch (identificationSourceType) {
            case IDENTIFICATION_SOURCE.NIC: {
                return 'green';
            }
            case IDENTIFICATION_SOURCE.PP: {
                return 'geekblue';
            }
            case IDENTIFICATION_SOURCE.DL: {
                return 'volcano';
            }
            default: {
                return '#8c8c8c';
            }
        }
    }

    const showModal = (record: BankDetailDto[]) => {
        setTempSecBankAccDOc(undefined)
        setTempPrimaryBankDoc(undefined)
        setFieldValues(record)
        setIsModalOpen(true);
        setPrimaryDefaultSelectedValue(null)
        setSecondaryDefaultSelectedValue(null)
        setPrimaryRejectReason(null)
        setSecondaryRejectReason(null)
        setSelectedRow(record)
    };

    useEffect(() => {
        if (!isCustomer()) {
            fetchCustomerBankDetailChangeRequestList()
        }
        getBankList()
    }, []);
    const getBankList = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BANK_LIST,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        loadCommonDropdownDataList(inputDropdownParameterDto, COMMON_DROPDOWN.BANK_LIST);
    }
    const getBranchList = (selectedBank: number, isPrimaryAcc: boolean) => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.BRANCH_LIST,
            findTextValue: "",
            parameterList: [[selectedBank], [PARAMETER_LIST.ACTIVE]]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                if (isPrimaryAcc) {
                    setBranchListPrimary(res.data.results.activeItemList)
                } else {
                    setBranchListSecondary(res.data.results.activeItemList)
                }
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_BRANCH_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setType = (type: COMMON_DROPDOWN, result: DropdownListDto[]) => {
        if (type == COMMON_DROPDOWN.BANK_LIST) {
            setBankList(result)
        }
    }
    const loadCommonDropdownDataList = (dropDownParameterDto: InputDropdownParameterDto, type: COMMON_DROPDOWN) => {
        customerService.getCommonDropdown(dropDownParameterDto).then(res => {
            if (res.data !== null) {
                setType(type, res.data.results.activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_BANK_LIST_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }
    const setFieldValues = (bankDetailList: BankDetailDto[]) => {
        bankDetailList.map((bankDetailDto) => {
            if (bankDetailDto.bankAccountType === "PRIMARY") {
                setPrimaryBankInfo(bankDetailDto)
            } else {
                setSecondaryBankInfo(bankDetailDto)
            }
        })

    }
    const showModalHst = (record: any) => {
        setFieldValues(record.pendingRequests)
        setSelectedGroupId(record.groupId)
        if (null != record.rejectReason) {
            setCanShowRejectReason(true)
            rejectReasonForm.setFieldsValue({rejectReason: record.rejectReason})
        } else {
            setCanShowRejectReason(false)
            rejectReasonForm.resetFields()
        }
        setShowCancelRequest(CHANGE_REQUEST_RECORD_STATUS.SUBMITTED == record.recordStatus)
        setIsModalOpen(true);
    };

    const setPrimaryBankInfo = (primaryAcc: BankDetailDto) => {
        setIsPrimaryInfoAvailable(true)
        getBranchList(primaryAcc.bankId, true)
        setJobNumber(primaryAcc.jobNumber ?? "")
        setCin(primaryAcc.cin ?? "")
        primaryBankAccForm.setFieldsValue(
            {
                id: primaryAcc.id,
                accountHolderName: primaryAcc.accountHolderName,
                accountNo: primaryAcc.accountNo,
                bankId: toNumber(primaryAcc.bankId),
                branchId: toNumber(primaryAcc.branchId),

            }
        )
        if (props.isFromHst) {
            loadUploadedDocumentsById(primaryAcc.jobNumber, primaryAcc.bankStatementDocId,
                [primaryAcc.recordStatus === "ACCEPTED" ? 'PBCL' : 'PBCL_TEMP'])
        } else {
            loadUploadedDocuments(primaryAcc.jobNumber, ['PBCL_TEMP', 'PBCL'])
        }
    }
    const setSecondaryBankInfo = (secondaryAcc: BankDetailDto) => {
        setIsSecondaryInfoAvailable(true)
        getBranchList(secondaryAcc.bankId, false)
        setCin(secondaryAcc.cin ?? "")
        secondaryBankAccForm.setFieldsValue(
            {
                id: secondaryAcc.id,
                accountHolderName: secondaryAcc.accountHolderName,
                accountNo: secondaryAcc.accountNo,
                branchId: secondaryAcc.branchId,
                bankId: secondaryAcc.bankId,

            }
        )
        if (props.isFromHst) {
            loadUploadedDocumentsById(secondaryAcc.jobNumber, secondaryAcc.bankStatementDocId,
                [secondaryAcc.recordStatus === "ACCEPTED" ? 'SBCL' : 'SBCL_TEMP'])

        } else {
            loadUploadedDocuments(secondaryAcc.jobNumber, ['SBCL_TEMP', 'SBCL'])
        }

    }
    const fetchCustomerBankDetailChangeRequestList = () => {
        setLoading(true)
        customerChangeRequestAdminService.getPendingBankDetailChangeRequest().then((res) => {
            if (res.data.results) {
                setBankDetailList(res.data.results.pendingRequests)
                console.log(res.data.results.pendingRequests)
                setLoading(false)
            } else {
                message.error(MSG_CONTACT_DETAIL_LIST_FETCH_FAILURE_ERROR)
                setLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
            setLoading(false)
        })
    }
    const handleCancel = () => {
        setPosition2({x: 100, y: 20});
        setIsModalOpen(false);
        setPreviewOpen(false);
        setPrimaryDefaultSelectedValue(null)
        setSecondaryDefaultSelectedValue(null)
        setPrimaryRejectReason(null)
        setSecondaryRejectReason(null)
        setTempSecBankAccDOc(undefined)
        setTempPrimaryBankDoc(undefined)
        resetModalFormFields();
    };

    const handlePrimaryBankRejectReasonCancel = () => {
        setPrimaryBankRejectReasonModalOpen(false);
        setPrimaryDefaultSelectedValue(null)
        setPrimaryRejectReason(null)
    };

    const handleSecondaryBankRejectReasonCancel = () => {
        setSecondaryBankRejectReasonModalOpen(false);
        setSecondaryDefaultSelectedValue(null)
        setSecondaryRejectReason(null)
    };

    const resetModalFormFields = () => {
        secondaryBankAccForm.resetFields()
        primaryBankAccForm.resetFields()
        setIsSecondaryInfoAvailable(false)
        setIsPrimaryInfoAvailable(false)
    }
    const loadUploadedDocuments = (jobNo: number | undefined, identityDocumentTypeCodeList: string[]) => {

        if (jobNo) {
            documentService.getUploadDocumentListByType(jobNo, identityDocumentTypeCodeList).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList(res.data.results)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }

    };
    const loadUploadedDocumentsById = (jobNo: number, docId: number, docTypeCode: string[]) => {
        documentService.getUploadDocumentListByTypeAndUploadedDocId(jobNo, docId, docTypeCode).then(res => {
            if (res.data !== null) {
                console.log(res.data.results)
                createUploadedDocuments(res.data.results[0].uploadDocumentDetailDto, res.data.results[0].documentTypeId)
            } else {
                message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        });
    };

    const setUploadedDocumentList = (documents: any) => {
        const tempDocuments = documents.filter(document => document.documentTypeCode.toString().includes('_TEMP'));
        tempDocuments.forEach((document: any) => {
            if (document.documentTypeId === DOCUMENT_TYPES.PBCL_TEMP) {
                if (document.uploadDocumentDetailDto != null) {
                    createUploadedDocuments(document.uploadDocumentDetailDto, document.documentTypeId)
                } else {
                    const pbclDocument = documents.find(document => document.documentTypeId === DOCUMENT_TYPES.PBCL);
                    createUploadedDocuments(pbclDocument.uploadDocumentDetailDto, document.documentTypeId)
                }
            } else if (document.documentTypeId === DOCUMENT_TYPES.SBCL_TEMP) {
                if (document.uploadDocumentDetailDto != null) {
                    createUploadedDocuments(document.uploadDocumentDetailDto, document.documentTypeId)

                } else {
                    const sbclDocument = documents.find(document => document.documentTypeId === DOCUMENT_TYPES.SBCL);
                    createUploadedDocuments(sbclDocument.uploadDocumentDetailDto, document.documentTypeId)
                }
            }

        })
    };
    const [tempPrimaryBankAccDoc, setTempPrimaryBankDoc] = useState<DefaultDocumentDto[]>()
    const [tempSecBankAccDOc, setTempSecBankAccDOc] = useState<DefaultDocumentDto[]>()

    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        if (documentTypeId == DOCUMENT_TYPES.PBCL_TEMP || documentTypeId == DOCUMENT_TYPES.PBCL) {
            setTempPrimaryBankDoc(defaultFileList)
            secondaryBankAccForm.setFieldsValue({uploadUtilityBill: defaultFileList})
        } else if (documentTypeId == DOCUMENT_TYPES.SBCL_TEMP || documentTypeId == DOCUMENT_TYPES.SBCL) {
            setTempSecBankAccDOc(defaultFileList)
            secondaryBankAccForm.setFieldsValue({uploadAdditional: defaultFileList})

        }
    }
    // const acceptRejectContactDetailChangeRequest = (type: RECORD_STATUS) => {
    //     handleCancel()
    //     modal.confirm({
    //         title: 'Confirm',
    //         className: 'confirm-dialog-box',
    //         icon: <ExclamationCircleOutlined/>,
    //         content: `Are you sure?, Do you want to ${type === RECORD_STATUS.ACCEPTED ? "accept" : "reject"} this bank details?`,
    //         okText: 'Yes',
    //         cancelText: 'No',
    //         okButtonProps: {style: {background: '#FF7400'}},
    //         onOk() {
    //             if (RECORD_STATUS.ACCEPTED == type) {
    //                 acceptRejectAccountRequest(type, selectedRow, undefined)
    //             } else {
    //                 setRejectReasonModalOpen(true)
    //             }
    //         },
    //         onCancel() {
    //             setLoading(false)
    //         }
    //     });
    // }

    const onCancelRequest = () => {
        setLoading(true)
        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to cancel this bank detail change request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                customerChangeRequestService.cancelCustomerBankChangeRequest(selectedGroupId as number).then(res => {
                    if (res.data !== null && res.data.results) {
                        message.success("Bank detail change request cancelled successfully").then();
                        handleCancel()
                        setLoading(false)
                        props.handleTabChange("1")
                    } else {
                        message.error("Bank detail change request cancel failure").then();
                        setLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setLoading(false)
                })
            },
            onCancel() {
                setLoading(false)
            }
        });
    }

    // const rejectRequest = (value: any) => {
    //     acceptRejectAccountRequest(RECORD_STATUS.REJECTED, selectedRow, value.rejectReason)
    // }

    // const acceptRejectAccountRequest = (type: RECORD_STATUS, record: BankDetailDto[], rejectReason: string | undefined) => {
    //     setLoading(true)
    //     if (RECORD_STATUS.REJECTED == type && undefined != rejectReason) {
    //         record.map((data) => {
    //             return data.rejectReason = rejectReason
    //         })
    //     }
    //     let primaryBankDto;
    //     let secondaryBankDto;
    //     record.map((data) => {
    //         data.recordStatus = type
    //         if (data.bankAccountType == "PRIMARY") {
    //
    //             primaryBankDto = data
    //         } else {
    //
    //             secondaryBankDto = data
    //         }
    //     })
    //     let addressWrapperDto = {
    //         primeryBankDetailDto: primaryBankDto,
    //         correspondenceBankDetailDto: secondaryBankDto
    //     }
    //     customerChangeRequestAdminService.acceptOrRejectBankDetailChangeRequest(addressWrapperDto, cin).then(res => {
    //         if (res.data !== null && res.data.results) {
    //             message.success(RECORD_STATUS.ACCEPTED == type ?
    //                 "Bank detail change request accepted successfully" :
    //                 "Bank detail change request rejected successfully").then();
    //             fetchCustomerBankDetailChangeRequestList()
    //             setRejectReasonModalOpen(false)
    //             setLoading(false)
    //         } else {
    //             message.error(RECORD_STATUS.ACCEPTED == type ?
    //                 "Bank detail change request accept failure" :
    //                 "Bank detail change request reject failure").then();
    //             setLoading(false)
    //         }
    //     }, (reason) => {
    //         ErrorHandler.handleError(reason);
    //         setLoading(false)
    //     })
    // }

    const getFormItemSet = (isPrimary: boolean) => {
        return < >
            <div style={{display: "none"}}>
                <Form.Item
                    label=""
                    name={"id"}>
                    <Input/>
                </Form.Item>
            </div>
            <Col span={12}>
                <Form.Item
                    label="Name of the Bank"
                    name={"bankId"}>
                    <Select placement='bottomLeft'
                            placeholder={"Select bank name"}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, option: {
                                label: any;
                            }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                            getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                            options={bankList}
                    />

                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Branch"
                    name={"branchId"}>
                    <Select placement='bottomLeft' defaultSelected={""}
                            placeholder={"Select branch"}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input: any, option: {
                                label: any;
                            }) => (option?.label.toLowerCase() ?? '').includes(input.toLowerCase())}
                            getPopupContainer={(trigger: { parentNode: any; }) => trigger.parentNode}
                            options={isPrimary ? branchListPrimary : branchListSec}
                    />

                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Account Number"
                    name={"accountNo"}
                    onKeyPress={Validation.isNumberWithoutDot}>
                    <Input placeholder={"Enter account number"}/>
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    label="Account Holder`s Name"
                    name={"accountHolderName"}
                    onKeyPress={Validation.onlyAlphabeticWithSpace}>
                    <Input type="text" placeholder={"Enter account holder`s name"}/>
                </Form.Item>
            </Col>

        </>
    }
    const openModal = (documentId: string, docTypeName: string) => {
        setLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPosition2({x: 100, y: 20});
                setPreviewOpen(true);
                setIsModalOpen(true);
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(checkDocumentContentType(res.data.results))
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };
    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }

    const onPrimaryBankStatusChange = (value: Event) => {
        if (RECORD_STATUS.REJECTED == value.target?.value) {
            setPrimaryBankRejectReasonModalOpen(true)
        } else {
            setPrimaryBankRejectReasonModalOpen(false)
            setPrimaryDefaultSelectedValue(RECORD_STATUS.ACCEPTED)
            setPrimaryRejectReason(null)
        }
    }
    const onSecondaryBankStatusChange = (value: Event) => {
        if (RECORD_STATUS.REJECTED == value.target?.value) {
            setSecondaryBankRejectReasonModalOpen(true)
        } else {
            setSecondaryBankRejectReasonModalOpen(false)
            setSecondaryDefaultSelectedValue(RECORD_STATUS.ACCEPTED)
            setSecondaryRejectReason(null)
        }
    }

    const onProceed = () => {
        let isCanProceed = false;
        if (selectedRow.length == 1) {
            if (null != primaryDefaultSelectedValue || null != secondaryDefaultSelectedValue) {
                isCanProceed = true
            } else {
                isCanProceed = false
                message.warning(MSG_PLEASE_SELECT_BANK_STATUS)
            }
        } else if (selectedRow.length == 2) {
            if (null != primaryDefaultSelectedValue && null != secondaryDefaultSelectedValue) {
                isCanProceed = true
            } else {
                isCanProceed = false
                message.warning(MSG_PLEASE_SELECT_BOTH_BANK_STATUES)
            }
        }
        if (isCanProceed) {
            setLoading(true)
            modal.confirm({
                title: 'Confirm',
                className: 'confirm-dialog-box',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure?, Do you want to proceed this bank details?`,
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: {style: {background: '#FF7400'}},
                onOk() {

                    let primaryBankDto;
                    let secondaryBankDto;
                    selectedRow.map((bank: BankDetailDto) => {
                        if ("PRIMARY" == bank.bankAccountType) {
                            bank.recordStatus = primaryDefaultSelectedValue
                            bank.rejectReason = primaryRejectReason as string
                            primaryBankDto = bank
                        } else if ("SECONDARY" == bank.bankAccountType) {
                            bank.recordStatus = secondaryDefaultSelectedValue
                            bank.rejectReason = secondaryRejectReason as string

                            secondaryBankDto = bank
                        }
                    })

                    let addressWrapperDto = {
                        primeryBankDetailDto: primaryBankDto,
                        correspondenceBankDetailDto: secondaryBankDto
                    }
                    customerChangeRequestAdminService.acceptOrRejectBankDetailChangeRequest(addressWrapperDto, cin).then(res => {
                        if (res.data !== null && res.data.results) {
                            message.success("Bank detail change request processed successfully").then();
                            fetchCustomerBankDetailChangeRequestList()
                            setIsModalOpen(false)
                            setLoading(false)
                        } else {
                            message.error("Failure to process bank detail change request").then();
                            setLoading(false)
                        }
                    }, (reason) => {
                        ErrorHandler.handleError(reason);
                        setLoading(false)
                    })
                },
                onCancel() {
                    setLoading(false)
                }
            });
        }
    }

    const rejectPrimaryRequest = (values: any) => {
        setPrimaryRejectReason(values.primaryRejectReason)
        setPrimaryDefaultSelectedValue(RECORD_STATUS.REJECTED)
        setPrimaryBankRejectReasonModalOpen(false)
    }

    const rejectSecondaryRequest = (values: any) => {
        setSecondaryRejectReason(values.secondaryRejectReason)
        setSecondaryDefaultSelectedValue(RECORD_STATUS.REJECTED)
        setSecondaryBankRejectReasonModalOpen(false)
    }
    return (
        <>
            <Row gutter={[24, 12]}>
                {
                    !props.isFromHst ?
                        <Col span={24}>
                            <Table size='small' dataSource={bankDetailList} columns={columns}
                                   scroll={{x: 'max-content'}}
                                   loading={isLoading}/>
                        </Col> :
                        <Col span={24}>
                            <ChangeRequestHistoryTableComp tableData={props.bankDetailDtoList}
                                                           onShowModal={showModalHst}
                                                           loading={isLoading}/>
                        </Col>
                }

            </Row>
            <Modal
                title={'Bank Details Update Request'}
                style={{top: 0, right: 0, margin: 20, marginTop: 20, position: 'absolute'}}
                maskStyle={{top: 0, left: 0}}
                open={isModalOpen} footer={null} onCancel={handleCancel} maskClosable={false}
                className={'modal-body-scroll-only disabled-data-show-inputs-container'}
                width={'50vw'}
                closable={false}
            >
                <Spin spinning={isLoading}>


                    <Row gutter={[24, 12]}
                         className={'form-item-mb-12 modal-body-scroll-only-main-row compare-modal-height bank-details-auth-modal-body-height'}>

                        {
                            isPrimaryInfoAvailable ?
                                <Col span={24}>
                                    <Card title="Primary Bank Account Details" size={'small'} extra={!props.isFromHst ?
                                        <Radio.Group buttonStyle="solid" onChange={onPrimaryBankStatusChange}
                                                     className={'auth-radio-group'}
                                                     value={primaryDefaultSelectedValue}>
                                            <Tooltip title="Authorize" placement={'bottom'} color={'#00c951'}>
                                                <Radio.Button value={RECORD_STATUS.ACCEPTED}>
                                                    <CheckOutlined style={{marginTop: 2}}/>
                                                </Radio.Button>
                                            </Tooltip>
                                            <Tooltip title="Reject" placement={'bottom'} color={'#fb2c36'}>
                                                <Radio.Button value={RECORD_STATUS.REJECTED}>
                                                    <CloseOutlined style={{marginTop: 2}}/>
                                                </Radio.Button>
                                            </Tooltip>

                                        </Radio.Group> : <></>
                                    }>
                                        <Form
                                            className='form-input'
                                            layout={"vertical"}
                                            form={primaryBankAccForm}
                                            disabled
                                        >
                                            <Row gutter={[12, 0]}>
                                                {
                                                    getFormItemSet(true)

                                                }
                                                <Col span={12}>
                                                    <Form.Item className={'form-item-label-only'}
                                                               label="Primary Bank Confirmation">
                                                    </Form.Item>

                                                    <div className='utility_bill img-nic' style={{width: '94%'}}>
                                                        <div className='utulity_bill_icon_div'>
                                                            <div className="img_div">
                                                                <img
                                                                    src={tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].thumbUrl : ''}
                                                                    alt=""/>
                                                            </div>
                                                            <div className='name_div'>
                                                                <h5>{tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].name : ''}</h5>
                                                            </div>
                                                        </div>
                                                        <Button disabled={false}
                                                                onClick={() => openModal(
                                                                    tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].uid : '',
                                                                    tempPrimaryBankAccDoc ? tempPrimaryBankAccDoc[0].name : '')}
                                                                className='doc-view-btn'><EyeOutlined/></Button>
                                                    </div>

                                                </Col>
                                                <Col span={24} className={'margin_top_10'}>
                                                    {null != primaryRejectReason ?
                                                        <Alert type="error" message="Reject Reason" showIcon
                                                               description={primaryRejectReason}/> : <></>
                                                    }

                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card>
                                </Col> : ''
                        }


                        {
                            isSecondaryInfoAvailable ?
                                <Col span={24}>
                                    <Card title="Secondary Bank Account Details" size={'small'}
                                          extra={!props.isFromHst ?
                                              <Radio.Group buttonStyle="solid" onChange={onSecondaryBankStatusChange}
                                                           className={'auth-radio-group'}
                                                           value={secondaryDefaultSelectedValue}>
                                                  <Tooltip title="Authorize" placement={'bottom'} color={'#00c951'}>
                                                      <Radio.Button value={RECORD_STATUS.ACCEPTED}>
                                                          <CheckOutlined style={{marginTop: 2}}/>
                                                      </Radio.Button>
                                                  </Tooltip>
                                                  <Tooltip title="Reject" placement={'bottom'} color={'#fb2c36'}>
                                                      <Radio.Button value={RECORD_STATUS.REJECTED}>
                                                          <CloseOutlined style={{marginTop: 2}}/>
                                                      </Radio.Button>
                                                  </Tooltip>
                                              </Radio.Group> : <></>
                                          }>
                                        <Form
                                            className='form-input'
                                            layout={"vertical"}
                                            form={secondaryBankAccForm}
                                            disabled
                                        >
                                            <Row gutter={[12, 0]}>
                                                {getFormItemSet(false)}

                                                <Col span={12}>
                                                    <Form.Item className={'form-item-label-only'}
                                                               label="Secondary Bank Confirmation">
                                                    </Form.Item>
                                                    <div className='utility_bill img-nic' style={{width: '94%'}}>
                                                        <div className='utulity_bill_icon_div'>
                                                            <div className="img_div">
                                                                <img
                                                                    src={tempSecBankAccDOc ? tempSecBankAccDOc[0].thumbUrl : ''}
                                                                    alt=""/>
                                                            </div>
                                                            <div className='name_div'>
                                                                <h5>{tempSecBankAccDOc ? tempSecBankAccDOc[0].name : ''}</h5>
                                                            </div>
                                                        </div>
                                                        <Button disabled={false}
                                                                onClick={() => openModal(
                                                                    tempSecBankAccDOc ? tempSecBankAccDOc[0].uid : '',
                                                                    tempSecBankAccDOc ? tempSecBankAccDOc[0].name : '')}
                                                                className='doc-view-btn'><EyeOutlined/></Button>
                                                    </div>


                                                </Col>
                                                <Col span={24} className={'margin_top_10'}>
                                                    {null != secondaryRejectReason ?
                                                        <Alert type="error" message="Reject Reason" showIcon
                                                               description={secondaryRejectReason}/> : <></>
                                                    }

                                                </Col>
                                            </Row>
                                        </Form>
                                    </Card>
                                </Col> : ''
                        }
                        {isShowRejectReason ?
                            <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                <Divider></Divider>

                                <Form form={rejectReasonForm}
                                      className='form-input'
                                      layout={"vertical"}
                                >
                                    <Form.Item

                                        name={"rejectReason"}
                                        label={"Reject Reason"}>
                                        <TextArea disabled bordered={true}/>
                                    </Form.Item>
                                </Form>
                            </Col>
                            :
                            <></>
                        }

                        <Col span={24} className={'draggable-footer-cancel-col'}>
                            <Divider style={{marginBottom: 12}}></Divider>
                            <Space style={{float: 'right'}}>

                                {
                                    !props.isFromHst ?
                                        <>
                                            {/*<Button icon={<CloseOutlined/>} danger*/}
                                            {/*        style={{*/}
                                            {/*            width: 100,*/}
                                            {/*            marginRight: 8*/}
                                            {/*            // background: "#ff4d4f",*/}
                                            {/*            // color: "white",*/}
                                            {/*        }}*/}
                                            {/*        onClick={() => acceptRejectContactDetailChangeRequest(RECORD_STATUS.REJECTED)}>Reject</Button>*/}
                                            {/*<Button icon={<CheckOutlined/>} type="success"*/}
                                            {/*        style={{*/}
                                            {/*            width: 100,*/}
                                            {/*            background: "#008d86",*/}
                                            {/*            color: "white",*/}
                                            {/*        }}*/}
                                            {/*        onClick={() => acceptRejectContactDetailChangeRequest(RECORD_STATUS.ACCEPTED)}>Accept</Button>*/}
                                            <Button
                                                onClick={handleCancel}
                                                style={{width: 80}}>Close</Button>
                                            <Button icon={<CheckOutlined/>} type="success"
                                                    style={{
                                                        width: 100,
                                                        background: "#008d86",
                                                        color: "white",
                                                    }}
                                                    onClick={() => onProceed()}>Proceed</Button>
                                        </> :

                                        isShowCancelRequest ?
                                            <Button
                                                onClick={onCancelRequest}>Cancel Request</Button> :
                                            <Button
                                                onClick={handleCancel}
                                                style={{width: 80}}>Cancel</Button>
                                }
                            </Space>
                        </Col>
                    </Row>

                </Spin>
            </Modal>
            <Modal title="Primary Bank Reject Reason"
                   open={isPrimaryBankRejectReasonModalOpen}
                   destroyOnClose={true}
                   maskClosable={false}
                   footer={null}
                   onCancel={handlePrimaryBankRejectReasonCancel}
            >
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            onFinish={rejectPrimaryRequest}
                        >
                            <Form.Item
                                name={"primaryRejectReason"}
                                label={"Reject Reason"}
                                rules={[{
                                    required: true,
                                    message: 'Please enter reject reason'
                                }]}>
                                <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                          bordered={true}/>
                            </Form.Item>
                            <Form.Item>
                                <Space style={{float: 'right'}}>
                                    <Button onClick={handlePrimaryBankRejectReasonCancel}>
                                        Cancel
                                    </Button>
                                    <Button htmlType="submit"
                                            type="primary">
                                        Submit
                                    </Button>
                                </Space>
                            </Form.Item>


                        </Form>
                    </Col>
                </Row>

            </Modal>
            <Modal title="Secondary Bank Reject Reason"
                   open={isSecondaryBankRejectReasonModalOpen}
                   destroyOnClose={true}
                   maskClosable={false}
                   footer={null}
                   onCancel={handleSecondaryBankRejectReasonCancel}
            >
                <Row>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Form
                            layout={"vertical"}
                            initialValues={{remember: true}}
                            onFinish={rejectSecondaryRequest}
                        >
                            <Form.Item
                                name={"secondaryRejectReason"}
                                label={"Reject Reason"}
                                rules={[{
                                    required: true,
                                    message: 'Please enter reject reason'
                                }]}>
                                <TextArea showCount placeholder="Please enter reject reason" maxLength={255}
                                          bordered={true}/>
                            </Form.Item>
                            <Form.Item>
                                <Space style={{float: 'right'}}>
                                    <Button onClick={handleSecondaryBankRejectReasonCancel}>
                                        Cancel
                                    </Button>
                                    <Button htmlType="submit"
                                            type="primary">
                                        Submit
                                    </Button>
                                </Space>
                            </Form.Item>


                        </Form>
                    </Col>
                </Row>

            </Modal>
            {/*<Modal*/}
            {/*    className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}*/}
            {/*    open={previewOpen}*/}
            {/*    centered*/}
            {/*    title={previewTitle}*/}
            {/*    onCancel={handlePreviewCancel}*/}
            {/*    destroyOnClose={true}*/}
            {/*    width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}*/}
            {/*    footer={[*/}
            {/*        <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}*/}
            {/*                htmlType="submit" onClick={() => download(docURL, previewTitle)}>*/}
            {/*            Download*/}
            {/*        </Button>]}>*/}
            {/*    <PreviewModalComp docURL={docURL}/>*/}
            {/*</Modal>*/}

            {previewOpen &&
                <div
                    ref={modalRef2}
                    className="draggable-modal"
                    style={{
                        position: 'fixed',
                        top: position2.y,
                        left: position2.x,
                        zIndex: 100000,
                        width: '40vw'
                    }}
                    onMouseDown={onMouseDown}
                >
                    <div className="draggable-modal-title-area">
                        <span className={'modal-title'}>{previewTitle}</span>
                        <Button icon={<CloseOutlined/>} size={'small'} onClick={handlePreviewCancel}/>
                    </div>
                    <div className="modal-body-area compare-preview-modal-height">
                        <PreviewModalComp docURL={docURL}/>
                    </div>
                    <div className="modal-footer-area">
                        <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                                htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                            Download
                        </Button>
                    </div>
                </div>
            }
        </>
    )
}
export default BankAccountDetailsUpdateRequestListComp;